export default __webpack_public_path__ + "static/lets-talk04-bc3c5ce712174c78a778e7e951f9899f.png";